import { useEffect, useRef } from "react";

export const FeedbackVideo = ({ children, ...props }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    let inViewport = false;
    let disposed = false;
    const shouldPlay = () => !disposed && inViewport && !document.hidden;
    const syncPlayback = () => {
      if (!shouldPlay()) {
        video.pause();
      } else if (video.paused) {
        // Browser autoplay restrictions may leave the poster visible instead.
        video.play()?.catch(() => {});
      }
    };
    const guardPlayback = () => {
      if (!shouldPlay()) video.pause();
    };
    const checkBounds = () => {
      const rect = video.getBoundingClientRect();
      inViewport = rect.bottom > 0 && rect.top < window.innerHeight
        && rect.right > 0 && rect.left < window.innerWidth;
      syncPlayback();
    };
    const observer = typeof IntersectionObserver === "undefined" ? null : new IntersectionObserver(([entry]) => {
      inViewport = entry.isIntersecting && entry.intersectionRatio > 0;
      syncPlayback();
    }, { threshold: 0 });

    video.addEventListener("play", guardPlayback);
    document.addEventListener("visibilitychange", syncPlayback);
    if (observer) {
      observer.observe(video);
    } else {
      checkBounds();
      window.addEventListener("scroll", checkBounds, { passive: true });
      window.addEventListener("resize", checkBounds);
    }

    return () => {
      disposed = true;
      observer?.disconnect();
      document.removeEventListener("visibilitychange", syncPlayback);
      window.removeEventListener("scroll", checkBounds);
      window.removeEventListener("resize", checkBounds);
      video.removeEventListener("play", guardPlayback);
      video.pause();
    };
  }, []);

  return <video {...props} ref={videoRef} loop muted playsInline preload="metadata">{children}</video>;
};